import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import Login from '../views/auth/login/Login';
import FollowBenefits from './FollowBenefits';

const LoginModal = ({ user, show, onHide, callback }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center text-dark">{t('Log In')}</Modal.Title>
      </Modal.Header>
      <FollowBenefits user={user} />
      <Modal.Body>
        <hr />
        <Login logo={false} callback={callback} style={{ background: 'none' }} formStyle={{ padding: 0 }} />
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
